
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Service from "./Pages/Service";
import About from "./Pages/About";
import Gallery from "./Pages/Gallery";
import Contact from "./Pages/Contact";
import Navigation from "./Pages/Navigation"; // 👈 import your Contact page

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Service />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/navigation" element={<Navigation />} />
        <Route path="/contact" element={<Contact />} /> {/* 👈 add route for Contact */}
      </Routes>
    </Router>
  );
}

export default App;
